export default "__VITE_ASSET__CALsApGq__"